import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import prospect from './prospect';
import assessmentSectionQuestions from './assessmentSectionQuestions';
import modal from './modal';

const appReducer = combineReducers({
    router: routerReducer,
    prospect,
    assessmentSectionQuestions,
    modal,
});

const reducers = (state, action) => {
    let updatedState = Object.assign({}, state);
    return appReducer(updatedState, action);
};

export default reducers;
